import { FAQS } from '../data/demoData';

const HowItWorksPage = () => (
  <div className="container" style={{paddingTop:"3rem",maxWidth:"1000px"}}>
    <h2 className="section-title" style={{textAlign:"center",marginBottom:"3rem"}}>How CoOwn Works</h2>
    {[
      {num:1,title:"Browse Curated Properties",desc:"Our acquisitions team vets every deal. Access detailed financials, projections, and due diligence documents before you invest."},
      {num:2,title:"Invest With Others",desc:"Buy shares starting at $500. Pay by card (USD wallet) or with USDC/ALGO on Algorand. Once fully funded, CoOwn forms an LLC, purchases the property, and manages everything."},
      {num:3,title:"Earn Passive Income",desc:"Receive monthly dividends from rental income. When tokenization is live for a property, on-chain share tokens (ASA) are minted to your embedded Algorand wallet."},
      {num:4,title:"Sell Anytime",desc:"List shares on our Secondary Marketplace for instant liquidity, or hold until property sale for full appreciation."},
    ].map(step => (
      <div key={step.num} style={{display:"flex",gap:"2rem",alignItems:"center",background:"var(--card)",padding:"2rem",borderRadius:"var(--radius)",boxShadow:"var(--shadow)",marginBottom:"1.5rem"}}>
        <div style={{width:60,height:60,background:"var(--primary)",color:"white",borderRadius:"50%",display:"flex",alignItems:"center",justifyContent:"center",fontSize:"1.5rem",fontWeight:700,flexShrink:0}}>{step.num}</div>
        <div><h3 style={{marginBottom:"0.5rem"}}>{step.title}</h3><p style={{color:"var(--text-light)"}}>{step.desc}</p></div>
      </div>
    ))}
    <h2 id="coown-faq" style={{textAlign:"center",margin:"3rem 0 2rem",scrollMarginTop:"5rem"}}>Frequently Asked Questions</h2>
    {FAQS.map((faq, i) => (
      <div key={i} className="agent-card" style={{cursor:"pointer"}} onClick={(e)=>e.currentTarget.classList.toggle("open")}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",fontWeight:600}}>
          {faq.q} <i className="fas fa-chevron-down"></i>
        </div>
        <div style={{color:"var(--text-light)",marginTop:"0.8rem",paddingTop:"0.8rem",borderTop:"1px solid var(--border)",display:"none"}} className="faq-answer">{faq.a}</div>
      </div>
    ))}
    <style>{`.agent-card.open .faq-answer { display: block !important; }`}</style>
  </div>
);

export default HowItWorksPage;
